/* eslint-disable camelcase */
import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import ToastComponent from '../../components/toast';
import { Wealthlane_Dtos_Production_ProductionResponseDto } from '@wealthlane/api-services/wealthlane-identity-service';
import { NotificationTemplateService } from '@wealthlane/api-services/wealthlane-notification-service';

const usePostImportNotificationTemplate = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  closeModal: () => void
): UseMutationResult<
  Wealthlane_Dtos_Production_ProductionResponseDto | undefined,
  unknown,
  any,
  unknown
> => {
  const queryClient = useQueryClient();
  return useMutation(
    async (payload: any) => {
      return await handleRequest(
        NotificationTemplateService.postApiNotificationApiAppNotificationTemplateImportNotificationTemplates(
          payload
        )
      );
    },
    {
      onSuccess: (response: any) => {
        if (response != null) {
          closeModal();
          queryClient.invalidateQueries('getEmailTemplates');
          toast.success(<ToastComponent label='Success' message='Email Template imported.' />);
        }
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default usePostImportNotificationTemplate;
